// Contact form (spec D7, as it behaved inside the former runtime): a submit opens the
// visitor's mail client on a message to contact@idealex.pro, or asks for the missing
// fields. All five forms (home and sub-pages) share the field names "Nom-Pr-nom", "Email"
// and "Message", which readFields() looks up by name.

const SELECTORS = {
  form: ".w-form form",
};

const FIELDS = {
  name: 'input[name="Nom-Pr-nom"]',
  email: 'input[name="Email"]',
  message: 'input[name="Message"]',
};

const MAILTO = "mailto:contact@idealex.pro";
const SUBJECT = "[iDeaLex]: Demande de contact";
const MISSING_FIELDS = "Veuillez remplir tous les champs requis.";

/** The visitor's entries; a field the form does not have reads as undefined. */
function readFields(form) {
  const value = (selector) => form.querySelector(selector)?.value;
  return { name: value(FIELDS.name), email: value(FIELDS.email), message: value(FIELDS.message) };
}

export function initContact() {
  for (const form of document.querySelectorAll(SELECTORS.form)) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const { name, email, message } = readFields(form);
      if (!name || !email || !message) {
        window.alert(MISSING_FIELDS);
        return;
      }
      const body = `Nom Prénom: ${name}\nEmail: ${email}\n\nMessage: ${message}`;
      window.location.href =
        `${MAILTO}?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(body)}`;
    });
  }
}
